// 需要缓存的组件
// 可以通过代码控制
// 通过 keep-alive 组件 include 实现，组件必须有 name 属性
export default [
  {
    path: '/timeTaskManage',
    name: 'JobManagement',
  },
  {
    path: '/audioParam',
    name: 'AudioParam',
  },
  {
    path: '/fieldServRecordQuery',
    name: 'OnSiteServiceRecord',
  },
  {
    path: '/videoPage',
    name: 'RecordVideoConfig',
  },
  {
    path: '/sysTransactionLog',
    name: 'TransactionLog',
  },
  {
    path: '/runLogMain',
    name: 'JobRunLog',
  },
  {
    path: '/sysLog',
    name: 'SysLog',
  },
  {
    path: '/logManage',
    name: 'PersonLogin',
  },
  {
    path: '/translogsocket',
    name: 'TransLogSocket',
  },
  {
    path: '/roleManage',
    name: 'RoleManagement',
  },
  {
    path: '/menuManagement',
    name: 'MenuManagement',
  },
  {
    path: '/funcManagement',
    name: 'FunctionManagement',
  },
  {
    path: '/organManage',
    name: 'InstitutionsManage',
  },
  {
    path: '/Terminal',
    name: 'TerminalMaintenance',
  },
  {
    path: '/userManagement',
    name: 'UserManagement',
  },
  {
    path: '/sysDictManagement',
    name: 'DictionaryManagement',
  },
  {
    path: '/paramManage',
    name: 'ParamSet',
  },
  {
    path: '/productHome/screen',
    name: 'ScreenManage',
  },
  {
    path: '/productHome/dealCollectTable',
    name: 'ProductReport',
  },
  {
    path: '/editUser',
    name: 'EditUser',
  },
  {
    path: '/addUser',
    name: 'AddUser',
  },
  {
    path: '/call-plan',
    name: 'CallPlanTable',
  },
  {
    path: '/leadCust',
    name: 'LeadTable',
  },
  {
    path: '/custList',
    name: 'CustomerList',
  },
  {
    path: '/add-risk-tip',
    name: 'AddRiskTip',
  },
  {
    path: '/edit-risk-tip',
    name: 'EditRiskTip',
  },
  {
    path: '/risk-tip',
    name: 'RiskTip',
  },
  {
    path: '/cds-list',
    name: 'CDSList',
  },
  {
    path: '/cds-detail',
    name: 'CDSDetail',
  },
  {
    path: '/exam-paper',
    name: 'ExamPaper',
  },
  {
    path: '/add-exam-paper',
    name: 'AddExamPaper',
  },
  {
    path: '/edit-exam-paper',
    name: 'EditExamPaper',
  },
  {
    path: '/financiaPrdDetail',
    name: 'FinancialDetail',
  },
  {
    path: '/annex-preview',
    name: 'AnnexPreview',
  },
  {
    path: '/makeUpEntrance',
    name: 'OnSiteServiceDetail',
  },
  {
    path: '/today-performance',
    name: 'TodayPerformance',
  },
  {
    path: '/latest-product',
    name: 'LatestProduct',
  },
];
